import React from 'react';
import MainHeader from './MainHeader';

const Header = () => {
  return <MainHeader />;
};

export default Header;
